import { Modal } from "antd";
import React, { useState } from "react";
import { indexRequest } from "../../indexRequest";
import { ModalStatusDelete } from "../../../../../Utils/modalStatus";

export const ModalDelete = ({ visible, onCancel, id, onDelete }) => {
  const [loading, setLoading] = useState(false);
  const [openModalStatus, setOpenModalStatus] = useState(false);

  const deletarPk = async () => {
    setLoading(true);
    try {
      const response = await indexRequest.deleteIndex(id);
      if (response.status === 204) {
        onCancel();
        onDelete((prevState) => {
          return prevState.filter((deleteValue) => {
            return deleteValue.id !== id;
          });
        });
        setOpenModalStatus(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal
        visible={visible}
        onCancel={onCancel}
        onOk={deletarPk}
        confirmLoading={loading}
      >
        <text style={{ fontWeight: "500", fontSize: 16 }}>
          Deseja deletar esta Index?
        </text>
      </Modal>

      <ModalStatusDelete
        onCancel={() => setOpenModalStatus(false)}
        visible={openModalStatus}
      />
    </>
  );
};
